import blogArticle from './dynamic/blog.article'

document.body.replaceWith(blogArticle)
